import { makeStyles } from '@mui/styles';

const styles = makeStyles(() => ({
	amountStyles: {
		display: 'flex',
		alignItems: 'center',
	},
	BadgeStyles: {
		marginLeft: 5,
	},
	secondaryTime: {
		color: 'gray',
	},
	ChipStyles: {
		borderRadius: 5,
		fontWeight: 'bolder',
		opacity: 0.8,
	},
	Heading: {
		fontSize: 16,
	},
	tableClass: {
		overflow: 'auto',
	},
	tableContainer: {
		marginTop: 15,
	},
	headingContainer: {
		backgroundColor: 'rgba(0, 0, 0, 0.08)',
	},
	tableRow: {
		border: '1px solid black',
	},
	noResultsClass: {
		padding: 30,
		display: 'flex',
		justifyContent: 'center',
	},
	noResultContainer: {
		padding: 10,
	},
	NoresultsPaper: {
		width: '420px',
	},
	container: {
		display: 'flex',
		justifyContent: 'center',
		marginTop: 150,
	},
	imgClass: {
		height: 200,
		width: 200,
		marginTop: '-75%',
	},
}));

export default styles;
